export const generalInformationCreateData = {
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    required: true,
  },
  fio: {
    key: "fio",
    label: "Фамилия, имя, отчество (при наличии)",
    type: "text",
    required: true,
  },
  login: {
    key: "login",
    label: "Логин",
    type: "text",
    required: true,
  },
  department: {
    key: "department",
    label: "Структурное подразделение",
    type: "selectSearch",
    required: true,
  },
  password: {
    key: "password",
    label: "Пароль",
    type: "password",
    required: true,
  },
  section: {
    key: "section",
    label: "Участок ГИМС",
    type: "selectSearch",
    required: false,
    options: [],
    onlyGims: true,
  },
  validUntil: {
    key: "validUntil",
    label: "Срок действия пароля",
    type: "date",
    required: true,
  },
  userPosition: {
    key: "userPosition",
    label: "Должность",
    type: "selectSearch",
    required: true,
  },
  registerLogin: {
    key: "registerLogin",
    label: "Логин для Регистра населения",
    type: "text",
    required: false,
  },
  registerPassword: {
    key: "registerPassword",
    label: "Пароль для Регистра населения",
    type: "password",
    required: false,
  },
};

export const generalInformationEditData = {
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    required: true,
  },
  fio: {
    key: "fio",
    label: "Фамилия, имя, отчество (при наличии)",
    type: "text",
    required: true,
  },
  login: {
    key: "login",
    label: "Логин",
    type: "text",
    required: true,
  },
  department: {
    key: "department",
    label: "Структурное подразделение",
    type: "selectSearch",
    required: true,
  },
  password: {
    key: "password",
    label: "Пароль",
    type: "password",
    disabled: true,
  },
  section: {
    key: "section",
    label: "Участок ГИМС",
    type: "selectSearch",
    options: [],
    onlyGims: true,
  },
  validUntil: {
    key: "validUntil",
    label: "Срок действия пароля",
    type: "date",
    disabled: true,
  },
  userPosition: {
    key: "userPosition",
    label: "Должность",
    type: "selectSearch",
    required: true,
  },
  registerLogin: {
    key: "registerLogin",
    label: "Логин для Регистра населения",
    type: "text",
    required: false,
  },
  registerPassword: {
    key: "registerPassword",
    label: "Пароль для Регистра населения",
    type: "password",
    required: false,
  },
};

export const generalInformationUpdateData = {
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    disabled: true,
  },
  fio: {
    key: "fio",
    label: "Фамилия, имя, отчество (при наличии)",
    type: "text",
    disabled: true,
  },
  login: {
    key: "login",
    label: "Логин",
    type: "text",
    disabled: true,
  },
  department: {
    key: "departmentName",
    label: "Структурное подразделение",
    type: "text",
    disabled: true,
  },
  password: {
    key: "password",
    label: "Пароль",
    type: "password",
    required: true,
  },
  section: {
    key: "sectionName",
    label: "Участок ГИМС",
    type: "text",
    disabled: true,
  },
  validUntil: {
    key: "validUntil",
    label: "Срок действия пароля",
    type: "date",
    required: true,
  },
  userPosition: {
    key: "userPositionName",
    label: "Должность",
    type: "text",
    disabled: true,
  },
  registerLogin: {
    key: "registerLogin",
    label: "Логин для Регистра населения",
    type: "text",
    disabled: true,
  },
  registerPassword: {
    key: "registerPassword",
    label: "Пароль для Регистра населения",
    type: "password",
    disabled: true,
  },
};

export const setDataGeneralInformation = async (prop, field) => {
  if (prop) {
    switch (field) {
      case "section": {
        generalInformationCreateData.section.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "section",
          };
        });
        generalInformationEditData.section.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "section",
          };
        });
        break;
      }
      case "department": {
        generalInformationCreateData.department.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "department",
          };
        });
        generalInformationEditData.department.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "department",
          };
        });
        break;
      }
      case "userPosition": {
        generalInformationCreateData.userPosition.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "userPosition",
          };
        });
        generalInformationEditData.userPosition.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "userPosition",
          };
        });
        break;
      }
      default:
        break;
    }
  }
};

export const getGeneralInformationCreateData = () =>
  generalInformationCreateData;
export const getGeneralInformationEditData = () => generalInformationEditData;
export const getGeneralInformationUpdateData = () =>
  generalInformationUpdateData;
